import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FormsService } from 'src/app/services/forms.service';
import { AppState } from 'src/app/store';
import * as fromProcess from '../../store/process/process.reducer';
import { Subject, takeUntil } from 'rxjs';
import { TrackingService } from 'src/app/tracking/tracking.service';
import { ProcessService } from 'src/app/services/process.service';

@Component({
  selector: 'app-load-policy-data',
  templateUrl: './load-policy-data.component.html',
})
export class LoadPolicyDataComponent implements OnInit, OnDestroy {
  policyData$ = this.store.select(fromProcess.selectPolicyData);
  policyNumber: string | null = null;
  leadId: string | null = null;

  ngDestroy$ = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private formsService: FormsService,
    private processService: ProcessService,
    private router: Router,
    private route: ActivatedRoute,
    private trackingService: TrackingService,
  ) {}

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.ngDestroy$)).subscribe((params) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      this.policyNumber = params['policyNumber'] || null;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      this.leadId = params['leadId'] || null;

      if (this.policyNumber !== null || this.leadId !== null) {
        this.formsService.resetApp();
        this.processService.setPolicyParams({ policyNumber: this.policyNumber, leadId: this.leadId });
        this.store.dispatch(fromProcess.actions.usePolicyDataStart({ policyNumber: this.policyNumber, leadId: this.leadId }));

        this.patchForms();
      }
    });
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  private patchForms() {
    this.policyData$.pipe(takeUntil(this.ngDestroy$)).subscribe((data) => {
      if (data && data.result) {
        const apiData = data.result;

        this.store.dispatch(fromProcess.actions.setKind({ kind: apiData.codeName }));
        this.trackingService.insuranceSubject(apiData.codeName);
        this.formsService.usePolicyData(apiData);

        if (apiData.selectedOffert) {
          this.store.dispatch(fromProcess.actions.selectPackage({ packageName: apiData.selectedOffert?.packageCodeName }));

          const selectedAddons: { [key: string]: boolean } = {
            TripAbortedAndDelayed: apiData.selectedOffert?.addOns?.['tripAbortedAndDelayed']?.selected,
            CDW: apiData.selectedOffert?.addOns?.['cdw']?.selected,
            AlcoholIncluded: apiData.selectedOffert?.addOns?.['alcoholIncluded']?.selected,
            ForTheActive: apiData.selectedOffert?.addOns?.['forTheActive']?.selected,
          };
          Object.entries(selectedAddons).forEach(([addon, value]: [string, boolean]) => {
            this.store.dispatch(fromProcess.actions.selectPackageAddons({ addon, value }));
          });
          const customizeAlcoholIncluded = apiData.selectedOffert?.addOns?.['alcoholIncluded']?.specifying;
          const customizeForTheActiveIncluded = apiData.selectedOffert?.addOns?.['forTheActive']?.specifying;

          if (customizeAlcoholIncluded) {
            this.store.dispatch(fromProcess.actions.setCustomizeAlcoholIncluded({ customizeAlcoholIncluded }));
          }
          if (customizeForTheActiveIncluded) {
            this.store.dispatch(fromProcess.actions.setCustomizeForTheActiveIncluded({ customizeForTheActiveIncluded }));
          }
        }

        if (apiData.backofficeSection) {
          this.formsService.updateBackofficeSection(apiData);
        }

        const premiumPercentIncrease = apiData?.agentSection?.premiumPercentIncrease;

        if (premiumPercentIncrease) {
          this.store.dispatch(fromProcess.actions.setAgentSectionPremiumPercentIncrease({ premiumPercentIncrease }));
        }

        if (apiData.discountCode) {
          this.store.dispatch(fromProcess.actions.fetchDiscountCodeStart({ discountCode: apiData.discountCode.code }));
        }

        this.store.dispatch(fromProcess.actions.goToStep({ step: 2 }));
        void this.router.navigate(['page', 'step2']);
      }
    });
  }
}
